<template>
  <section class="classification-matches-range-activetime">
    <HeaderComponent
      title="Clasificación de partidos por rango de tiempo activo"
      titlemovil="Clasificación de partidos por </br> rango de tiempo activo"
    />
    <div class="classification-matches-range-activetime__cont-bar-elements">
      <SwitchPercentOrNumberClassification v-if="false" />
      <ButtonMoreTournaments @openmodal="openmodal" v-if="false" />
    </div>
    <div class="classification-matches-range-activetime__cont-table">
      <TableClassification :data="arrayComparison" />
    </div>
    <ModalClassificationMatchesRangeActiveTime :show="modal" @onCancel="onCancel" />
  </section>
</template>

<script>
import axios from 'axios';
export default {
  name: 'ClassificationMatchesRangeActiveTime',
  components: {
    HeaderComponent: () => import('@/components/ActiveTime/Elements/HeaderComponent'),
    TableClassification: () => import('@/components/ActiveTime/Elements/TableClassification'),
    // ButtonMoreTournaments: () => import('@/components/ActiveTime/Elements/ButtonMoreTournaments'),
    // SwitchPercentOrNumberClassification: () =>
    //   import('@/components/ActiveTime/Elements/SwitchPercentOrNumberClassification'),
    ModalClassificationMatchesRangeActiveTime: () =>
      import('@/components/ActiveTime/Modals/ModalClassificationMatchesRangeActiveTime'),
  },
  props: {
    /**
     * Seasons objects to fetch games
     * {Array<{id: number, type: number}>} seasons
     */
    seasons: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    seasons: {
      immediate: true,
      deep: true,
      handler: async function(newValue) {
        if (newValue && newValue.length) {
          const season = newValue.filter(season => season.type === 0)[0];
          await this.getComparisonMatches(season.id);
        }
      },
    },
  },
  computed: {},
  data() {
    return {
      modal: false,
      url: 'https://6smb5j9iia.execute-api.us-east-2.amazonaws.com/prod/te/comparison/',
      arrayComparison: [],
    };
  },
  methods: {
    openmodal() {
      this.modal = true;
    },
    onCancel() {
      this.modal = false;
    },
    async getComparisonMatches(season) {
      var s = 1;
      if (this.$route.query.s) {
        if (this.$route.query.s == 1 || this.$route.query.s == 0) {
          s = this.$route.query.s;
        }
      }
      const comparisonData = await axios
        .get(this.url + season + '?s=' + s)
        .then(response => response)
        .catch(e => {
          if (this.retries > 0) {
            this.retries = this.retries - 1;
            return this.getComparisonMatches(season);
          }
          return e;
        });
      this.arrayComparison = [];
      if (comparisonData.data != '') {
        for (let index = 0; index < comparisonData.data.length; index++) {
          var seasonSplit = comparisonData.data[index].season_name.split(' ');
          this.arrayComparison.push({
            season: comparisonData.data[index].season_name,
            seasonShort: seasonSplit[0].charAt(0) + seasonSplit[1],
            lap1: comparisonData.data[index].classification[0],
            lap2: comparisonData.data[index].classification[1],
            lap3: comparisonData.data[index].classification[2],
            lap4: comparisonData.data[index].classification[3],
          });
        }
      }
    },
  },
};
</script>
<style lang="scss">
.topf-container {
  .menu-top .switch input[type='checkbox'] + .check.is-success-passive,
  .menu-top .switch input[type='checkbox'] + .check:hover {
    background: #cbee6b !important;
  }
  .switch input[type='checkbox'] + .check.is-success-passive,
  .switch input[type='checkbox'] + .check:hover,
  .switch input[type='checkbox']:checked + .check:hover {
    background: #cbee6b !important;
    box-shadow: none !important;
  }
  .switch.is-rounded input[type='checkbox'] + .check:before {
    background: #132839 !important;
    box-shadow: none !important;
  }
  .switch input[type='checkbox'] + .check {
    background: #cbee6b !important;
    box-shadow: none !important;
  }
}
</style>
<style lang="scss" scoped>
.classification-matches-range-activetime {
  &__cont-bar-elements {
    width: 100%;
    height: 22px;
    // background: purple;
    margin-top: 10px;
    display: inline-flex;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    @media screen and (max-width: 680px) {
      display: inline-block;
    }
  }
  &__cont-table {
    width: 100%;
    height: 231px;
    border-radius: 8px;
    border: solid 1px #132739;
    margin-top: 10px;
  }
}
</style>
